export const SHOW_PAYMENT_SUCCESS = 'SHOW_PAYMENT_SUCCESS'
export const SHOW_PAYMENT_FAIL = 'SHOW_PAYMENT_FAIL'
export const HIDE_PAYMENT = 'HIDE_PAYMENT'
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
